import createAsyncActionType from "../../../utilities/createAsyncActionType";

export const GET_MONITORING_QUEUE_ENTRIES = createAsyncActionType(
  "GET_MONITORING_QUEUE_ENTRIES"
);

export const GET_MONITORING_QUEUE_ENTRIES_COUNT = createAsyncActionType(
  "GET_MONITORING_QUEUE_ENTRIES_COUNT"
);

export const GET_MONITORING_QUEUE_ENTRY_DETAILS = createAsyncActionType(
  "GET_MONITORING_QUEUE_ENTRY_DETAILS"
);

export const UPDATE_CLIENT_SCORING_RESULT_STATUS = createAsyncActionType(
  "UPDATE_CLIENT_SCORING_RESULT_STATUS"
);

export const CREATE_WATCHLIST_IGNORING_PROPERTY = createAsyncActionType(
  "CREATE_WATCHLIST_IGNORING_PROPERTY"
);

export const EXPORT_MONITORING_QUEUE = createAsyncActionType(
  "EXPORT_MONITORING_QUEUE"
);

export const GET_SCORE_CARD_RISK_FACTORS = createAsyncActionType(
  "GET_SCORE_CARD_RISK_FACTORS"
);

export const CREATE_NEGATIVE_MEDIA_IGNORING_PROPERTY = createAsyncActionType(
  "CREATE_NEGATIVE_MEDIA_IGNORING_PROPERTY"
);

export const GET_SCORING_DECISION_TEMPLATE = createAsyncActionType(
  "GET_SCORING_DECISION_TEMPLATE"
);

export const CLEAR_SCORING_DECISION_TEMPLATE =
  "CLEAR_SCORING_DECISION_TEMPLATE";

export const SET_MONITORING_QUEUE_ENTRY_SEARCH_FILTERS =
  "SET_MONITORING_QUEUE_ENTRY_SEARCH_FILTERS";

export const SET_MONITORING_QUEUE_ENTRY_CURRENT_PAGE =
  "SET_MONITORING_QUEUE_ENTRY_CURRENT_PAGE";

export const SET_MONITORING_QUEUE_ENTRY_ITEMS_PER_PAGE =
  "SET_MONITORING_QUEUE_ENTRY_ITEMS_PER_PAGE";

export const CLEAR_MONITORING_QUEUE_ENTRIES = "CLEAR_MONITORING_QUEUE_ENTRIES";

export const CLEAR_MONITORING_QUEUE_ENTRY_DETAILS =
  "CLEAR_MONITORING_QUEUE_ENTRY_DETAILS";

export const SET_MONITORING_QUEUE_TABLE_CHECKBOX_CHECKED =
  "SET_MONITORING_QUEUE_TABLE_CHECKBOX_CHECKED";

export const SET_TABLE_HEADER_DROPDOWN_VALUE =
  "SET_TABLE_HEADER_DROPDOWN_VALUE";

export const SET_SELECTED_ENTRIES = "SET_SELECTED_ENTRIES";

export const SET_DESELECTED_ENTRIES = "SET_DESELECTED_ENTRIES";

export const SET_MONITORING_QUEUE_ENTRY_NO_ENTRIES_MESSAGE =
  "SET_MONITORING_QUEUE_ENTRY_NO_ENTRIES_MESSAGE";



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/types/monitoringQueueEntryTypes.js